<template>
  <LayoutHeader class="layoutHeader">
    <!-- 系统Logo -->
    <div class="logoWrap">
      <img src="../../assets/images/txLogo.png" class="logo"/>
      <span class="siteName">{{isAiCenter? 'AI订单系统' : 'RIS系统'}}</span>
    </div>
    <!-- 顶部菜单 -->
    <Menu mode="horizontal" theme="dark" v-model="curIndex" class="headerMenu" >
      <MenuItem v-for="item in menus" :key="item.pid" @click.native="menuClick(item)">{{item.title}}</MenuItem>
    </Menu>
    <!-- 系统通知 -->
    <HeaderNotice/>
    <!-- 用户操作 -->
    <UserMenu/>
  </LayoutHeader>
</template>
<script>
import { Layout, Menu } from 'ant-design-vue'
import UserMenu from '../UserMenu'
import HeaderNotice from '../HeaderNotice'
import { getSession, setSession } from '../../libs/utils'
import { getNoticeList } from '../../api/user'
import { mapActions, mapState } from 'vuex'
import { getAiCheckImageCenterId } from '../../config'
export default {
  components: {
    LayoutHeader: Layout.Header,
    Menu,
    MenuItem: Menu.Item,
    UserMenu,
    HeaderNotice
  },
  data () {
    return {
      curIndex: [],
      menus: [],
    }
  },
  computed: {
    ...mapState({
      currentCenterId: state => state.app.currentCenterId
    }),
    isAiCenter() {
      if (this.currentCenterId == getAiCheckImageCenterId()) return true
      return false
    }
  },
  created () {
    let menus = getSession('userAuth', 'object').authMenus || []
    this.menus = menus
    this.updateMenu()
  },
  async mounted () {
    let list = await getNoticeList({pageNo: 1, pageSize: 10, readFlag: 0})
    if (list && list.totalCount > 0) this.setHasNewNotice(true)
    else this.setHasNewNotice(false)
  },
  methods: {
    ...mapActions([
      'setHasNewNotice'
    ]),
    menuClick (item) {
      setSession('currentMenuPid', item.pid)
      if (item.resources === 'ris/queue' || item.resources === 'ris/callNum') {
        setSession('oldDeviceId', '' + this.$route.name)
        setSession('scrollTop', 0)
      }
      this.curIndex = [parseInt(item.pid, 10)]
      this.$router.push({path: `/${item.resources}`}).catch(()=>{})
      return
    },
    updateMenu () {
      let currentRoute = this.$route.path
      for (let i = 0; i < this.menus.length; i++) {
        let menuItem = this.menus[i]
        if (currentRoute.includes(menuItem.resources)) {
          return this.curIndex = [parseInt(menuItem.pid, 10)]
        }
      }
      this.curIndex = []
    }
  },
  watch: {
    $route () {
      this.updateMenu()
    }
  }
}
</script>
<style lang="less">
.layoutHeader{
  display: flex;
  .logoWrap{
    margin-right: 20px;
    .logo{
      object-fit: contain;
      height: 36px;
      width: 36px;
    }
    .siteName{
      color:#fff;
      vertical-align: top;
      font-size: 16px;
      margin: 0 0 0 12px;
      font-weight: 600;
    }
  }
  .headerMenu{
    line-height: 64px;
    flex:1;
  }
  .userWrapper{
    justify-self: flex-end;
    display: flex;
    color: #fff;
    .dropDown{
      cursor: pointer;
    }
    .userAvatar{
      padding: 0 12px;
      .userName{
        margin-left: 10px;
      }
    }
  }
  @media screen and (max-width: 576px) {
    .logoWrap{
      margin-right: 20px;
      .logo{
        object-fit: contain;
        height: 20px;
        width: 20px;
      }
    }
    ul.headerMenu.ant-menu.ant-menu-horizontal.ant-menu-root.ant-menu-dark{
      max-width: 100px;
    }
  }
}
@media all and (max-width: 767px) {
  .ant-layout-header{
    padding: 0;
    .logoWrap{
      margin-left: 15px;
    }
    .noticeComponent{
      display: none;
    }
  }
}
</style>